'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseForm', ['$scope', '$stateParams', '$q', 'FBForms', 'FBFormTypes', function ($scope, $stateParams, $q, FBForms, FBFormTypes) {
        $scope.resetLicense();
        $scope.masterForm = $stateParams.form;
        $scope.form = $stateParams.form;
        $scope.formID = $stateParams.formID;
        $scope.formType = {};
        $scope.formLoading = true;

        $scope.setMasterForm = function (form) {
            if ($scope.license != null && $scope.license.forms) {
                updateArray($scope.license.forms, form);
                updateArray($scope.masterLicense.forms, form);
            }
            $scope.masterForm = form;
            $scope.form = angular.copy($scope.masterForm);
        }

        $scope.resetForm = function () {
            if ($scope.masterForm == null) {
                $scope.masterForm = {};
            }
            $scope.form = angular.copy($scope.masterForm);
        }

        var promises = [];

        promises.push(FBFormTypes.getByCode('application').then(function (formType) {
            $scope.formType = formType;
            if ($stateParams.formID == null) {
                var form = { name: 'New Form', display_page_links: true, form_type_id: formType.id, pages: [{ id: guid(), name: 'Page 1', show_save_button: false, continue_button_label: 'Save and Continue', save_button_label: 'Save', tab_active: true, sort_order: 0, sections: [{ id: guid(), name: 'Section 1', sort_order: 0, questions: [] }] }] };
                $scope.setMasterForm(form);
            }
        }));

        if ($stateParams.formID != null) {
            promises.push(FBForms.getByID($stateParams.formID).then(function (form) {
                if (form.pages.length > 0) {
                    form.pages[0].tab_active = true;
                }
                $scope.showTriggers = true;
                if (form.start_trigger_name != null && form.start_trigger_name.indexOf(form.name) > 0 && form.complete_trigger_name != null && form.complete_trigger_name.indexOf(form.name) > 0) {
                    $scope.showTriggers = false;
                }
                $scope.setMasterForm(form);
            }));
        }

        $q.all(promises).then(function () {
            $scope.formLoading = false;
        }).catch(function (response) {
            // handle error
        });
    }])
;